import { render } from "./SignoutForm.vue?vue&type=template&id=23862905&scoped=true"
import script from "./SignoutForm.vue?vue&type=script&lang=js"
export * from "./SignoutForm.vue?vue&type=script&lang=js"

import "./SignoutForm.vue?vue&type=style&index=0&id=23862905&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23862905"]])

export default __exports__